<template>
  <div class="sf-pad-t-3 sf-pad-b-3">
    <div class="sf-level sf-level-between sf-below-3">
      <div class="sf-level-item">
        <div class="sf-font-l sf-title">
          {{ I18n.t('communication.messages.title') }}
        </div>
      </div>
      <div class="sf-level-item">
        <new-remark-button
          :ledger-id="ledgerId"
          :ledger-label="ledgerPeriodName"
          :owner-id="contextId"
          extra-classes="sf-full sf-alignc sf-btn"
          owner-type="Account"
          @click="closeCurrentModal"
        />
      </div>
    </div>
    <div class="sf-grid sf-grid-fluid">
      <div v-if="fetchingCommunicationsInProgress" class="sf-row">
        <div class="sf-col sf-align-c">
          <div class="sf-spinner sf-inline-block" />
        </div>
      </div>
      <template v-else>
        <template v-if="!showTodosEmptyState || !showNotesEmptyState">
          <div class="sf-row">
            <div class="sf-col">
              <template v-if="showNotesEmptyState">
                <div v-if="showNotesEmptyState" class="sf-align-c sf-below-3">
                  <div
                    class="sf-c-text-light"
                    style="
                      display: inline-block;
                      height: 107.5px;
                      width: 107.5px;
                      background-color: #fbfbfb;
                      font-size: 45px;
                      border-radius: 50%;
                      line-height: 107.5px;
                    "
                  >
                    <i class="i-no-notes" />
                  </div>
                </div>
              </template>
              <template v-else>
                <RemarkV2
                  v-for="remark in sortedNotes"
                  :key="remark.id"
                  show-tags
                  :remark="remark"
                />
              </template>
            </div>
            <div class="sf-col">
              <template v-if="showTodosEmptyState">
                <div v-if="showTodosEmptyState" class="sf-align-c sf-below-3">
                  <div
                    class="sf-c-text-light"
                    style="
                      display: inline-block;
                      height: 107.5px;
                      width: 107.5px;
                      background-color: #fbfbfb;
                      font-size: 45px;
                      border-radius: 50%;
                      line-height: 107.5px;
                    "
                  >
                    <i class="i-no-todos" />
                  </div>
                </div>
              </template>
              <template v-else>
                <RemarkV2
                  v-for="remark in sortedPendingTodos"
                  :key="remark.id"
                  show-tags
                  :remark="remark"
                />
                <check-list
                  v-for="checkList in sortedPendingCheckLists"
                  :key="checkList.id"
                  ref="checkList"
                  v-bind="checkList"
                />
                <template v-if="showingCompletedTodosAndCheckLists">
                  <RemarkV2
                    v-for="remark in sortedCompleted"
                    :key="remark.id"
                    show-tags
                    :remark="remark"
                  />
                  <check-list
                    v-for="checkList in sortedCompletedCheckLists"
                    :key="checkList.id"
                    ref="checkList"
                    v-bind="checkList"
                  />
                </template>
              </template>
              <div v-if="completedCount">
                <div class="sf-align-c sf-below-4">
                  <a
                    class="sf-btn sf-btn-small"
                    @click.prevent="toggleCompletedTodosAndCheckLists"
                  >
                    {{
                      I18n.t(
                        'communication.todos.toggle_completed.' +
                          showingCompletedTodosAndCheckLists,
                        { count: completedCount }
                      )
                    }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="sf-row sf-row-center">
            {{ I18n.t('communication.messages.no_messages_posted') }}
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import twoColumnsCommunication from './mixins/two-columns-communication'

import CheckList from './checks/check-list'
import newRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button'
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'

const InteractiveReportCommunication = {
  name: 'InteractiveReportCommunication',
  components: {
    RemarkV2,
    CheckList,
    newRemarkButton,
  },
  mixins: [twoColumnsCommunication],
  methods: {
    // scrolling to anchor
    handleAnchorScroll() {
      this.expandHiddenItems().then(() => {
        const elementSelector = this.elementAnchorLink()

        this.highlightCardBeforeScroll({ elementId: elementSelector })
        this.scrollTo(elementSelector, '.sf-modal-backdrop').then(() => {
          this.anchorElementScrolled = true
        })
      })
    },
    closeCurrentModal() {
      window.modalCitizen.closeModalXhr('interactive-report-communication')
    },
  },
}

export default InteractiveReportCommunication
</script>
